import { useMutation } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const downloadCSV = async (body) => {
  const path = '/mp_catalogues/csv/';
  try {
    // Première requête pour obtenir le chemin du fichier
    const response = await axiosInstance.post(path, { ...body, async: true });
    const { zip_file_path, success, error: exportError } = response.data;

    if (!zip_file_path) {
      return { async: true };
    }

    // Construire l'URL complète du fichier
    const baseUrl = import.meta.env.VITE_PROMETHEE_BACK_BASE_URL;
    const fileUrl = `${baseUrl}/${zip_file_path}`;

    // Extraire le nom du fichier du chemin
    const filename = zip_file_path.split('/').pop();

    return { fileUrl, filename, success, exportError };
  } catch (error) {
    console.error('Download CSV API error:', error);
    throw error;
  }
};

export const useDownloadCSV = (options = {}) => {
  const mutation = useMutation({
    mutationFn: downloadCSV,
    onSuccess: (data, variables) => {
      if (data.async) {
        options.onSuccess?.(data, variables);
        return;
      }

      const { fileUrl, filename } = data;

      // Créer un lien de téléchargement automatique
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', options.filename || filename);
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
      link.remove();

      options.onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      console.error('Mutation error:', error);
      options.onError?.(error, variables);
    },
    ...options,
  });

  return {
    downloadCSV: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    data: mutation.data,
    reset: mutation.reset,
  };
};
